import { ReactNode } from "react";
import { Icon, Modal } from "~components";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";

export type WarningModalProps = {
  onClose: () => void;
  onContinue: () => void;
  confirmationMessage: ReactNode | string;
  title: string;
  actionButtonText?: string;
};

export function WarningModal(props: WarningModalProps) {
  const { onClose, onContinue, title, confirmationMessage, actionButtonText = "SELECT" } = props;
  const tid = useTestIds(props, "warningModal");

  return (
    <Modal
      size={{ width: "max-content", height: "max-content", maxWidth: "489px" }}
      title={
        <div css={Css.df.jcfs.gap2.$}>
          <Icon name="warning-icon-large" />
          <span css={Css.t24.$}>{title}</span>
        </div>
      }
      description={confirmationMessage}
      actionBtns={[
        { variant: "link", children: "CANCEL", xss: Css.$, onClick: onClose },
        {
          children: actionButtonText,
          rounded: true,
          // TODO: Is it worth making a modal confirm variant? Probably
          xss: Css.ttu.wPx(154).hPx(35).pxPx(56).pyPx(9).borderRadius("17.5px").$,
          onClick: () => {
            onContinue();
            onClose();
          },
        },
      ]}
      isOpen
      close={onClose}
      {...tid}
    ></Modal>
  );
}
